export const calendar = {
  title: 'Mijn Agenda',
  subtitle: 'Beheer uw beschikbaarheid en synchroniseer uw kalenders',
  calendar: {
    today: 'Vandaag',
    month: 'Maand',
    week: 'Week',
    day: 'Dag',
    selectDates: 'Selecteer datums',
    blockDates: 'Datums blokkeren',
    unblockDates: 'Deze datums deblokkeren',
    addNote: 'Opmerking toevoegen',
    selectEvent: 'Selecteer een evenement',
    nMonths: 'maanden',
    oneMonth: '1 maand',
    months: { january: 'Januari', february: 'Februari', march: 'Maart', april: 'April', may: 'Mei', june: 'Juni', july: 'Juli', august: 'Augustus', september: 'September', october: 'Oktober', november: 'November', december: 'December' },
    days: { monday: 'Ma', tuesday: 'Di', wednesday: 'Wo', thursday: 'Do', friday: 'Vr', saturday: 'Za', sunday: 'Zo' }
  },
  sync: { title: 'iCal-synchronisatie', description: 'Verbind uw Airbnb- of PMS-kalender om uw beschikbaarheid automatisch te synchroniseren', addConnection: 'Verbinding toevoegen', noConnections: 'Geen verbindingen', icalUrl: 'iCal-URL', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Platform', platformPlaceholder: 'Bijv.: Airbnb, Booking.com, PMS...', syncNow: 'Nu synchroniseren', lastSync: 'Laatst gesynchroniseerd', eventsImported: 'evenementen geïmporteerd', status: { synced: 'Gesynchroniseerd', pending: 'In behandeling', error: 'Fout', syncing: 'Synchroniseren...' }, remove: 'Verwijderen', edit: 'Bewerken' },
  exchanges: { title: 'Aankomende Uitwisselingen', noExchanges: 'Geen uitwisselingen gepland', viewProfile: 'Profiel bekijken', sendMessage: 'Bericht verzenden', confirm: 'Bevestigen', decline: 'Afwijzen', cancel: 'Annuleren', guests: 'reizigers', status: { confirmed: 'Bevestigd', pending: 'In behandeling', proposal: 'Voorstel', blocked: 'Geblokkeerd' } },
  legend: { title: 'Legenda', available: 'Beschikbaar', confirmed: 'Bevestigde uitwisseling', pending: 'Aanvraag in behandeling', proposal: 'Voorstel', blocked: 'Geblokkeerde datums' },
  blockModal: { title: 'Datums blokkeren', reason: 'Reden (optioneel)', reasonPlaceholder: 'Bijv.: Renovaties, persoonlijke vakantie...', from: 'Van', to: 'Tot', block: 'Blokkeren', cancel: 'Annuleren' },
  notifications: { datesBlocked: 'Datums succesvol geblokkeerd', datesUnblocked: 'Datums succesvol gedeblokkeerd', syncSuccess: 'Synchronisatie geslaagd', syncError: 'Synchronisatiefout', connectionAdded: 'Verbinding succesvol toegevoegd', connectionRemoved: 'Verbinding verwijderd', exchangeConfirmed: 'Uitwisseling bevestigd', exchangeDeclined: 'Uitwisseling geweigerd' },
  details: 'Gegevens',
  upcomingExchanges: 'Aankomende Uitwisselingen',
  noExchangesPlanned: 'Geen uitwisselingen gepland',
  daysSelected: 'dagen geselecteerd',
  daySelected: 'dag geselecteerd',
  from: 'Van',
  to: 'Tot',
  reasonOptional: 'Reden (optioneel)',
  reasonPlaceholder: 'Bijv.: Renovaties, persoonlijke vakantie...',
  block: 'Blokkeren',
  cancel: 'Annuleren',
  namePlaceholder: 'Naam (bijv.: Airbnb)',
  filters: 'Filters',
  actions: 'Acties',
  connections: 'Verbindingen'
};

export default calendar;
